
import LoginPage from "@/pages/LoginPage.vue";

import { useStore } from 'vuex'
import { computed } from 'vue'
import {useRouter} from "vue-router";
import CreatePage from "@/pages/CreatePage.vue";
import CustomerPage from "@/pages/CustomerPage.vue";

export default {
  components: {
    LoginPage,
    CreatePage,
    CustomerPage
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    const router = useRouter();
    const permission = computed(() => {
      return !!store.state.token && store.state.permission === 'admin'
    })

    console.log("isLoggedIn: " + isLoggedIn);
    // router.push({
    //   name: 'sendmessage'
    // });
    return {
      isLoggedIn,
      permission
    }
  }
}
